import { useContext, useMemo } from 'react';
import SavedSearchesContext from '~/contexts/SavedSearchesContext';
import type { SavedSearch } from '~/contracts';

export type SavedSearchWithText = SavedSearch & {
  highlightedText: string;
  text: string;
};

export default function useSavedSearches(): SavedSearchWithText[] {
  const { savedSearches } = useContext(SavedSearchesContext);

  return useMemo(
    () =>
      savedSearches
        .map<SavedSearchWithText>(v => ({
          ...v,
          highlightedText: '',
          text: v.name
        }))
        .sort((a, b) => b.savedSearchId - a.savedSearchId)
        .slice(0, 3),
    [savedSearches]
  );
}
